<div class="zesty-modal__backdrop animated fadeIn">
	<div class="zesty-modal__wrapper">
		<div class="zesty-modal">
			<div class="zesty-modal__header">
				<h3 class="zesty-modal__title">{{data?.title}}</h3>
			</div>
			<div class="zesty-modal__content">
				<br>
				<p>You are about to delete the following link:</p>
				<div>
					<div><b>-Account name:</b> {{ link.account_name }}</div>
					<div><b>-Company:</b> {{ link.organization }}</div>
				</div>
				<br>
				<div>Are you sure?</div>
			</div>
			<div class="zesty-modal__actions">
				<button class="zesty-modal__close" (click)="closeEvent()">Close</button>
				<button class="zesty-modal__create-btn delete"
								(click)="confirmDelete()">
					Confirm
				</button>
			</div>
		</div>
	</div>
</div>
